// extracted by mini-css-extract-plugin
module.exports = {"videoContainer":"gttl-photo-wall_videoContainer__z4iIy","video":"gttl-photo-wall_video__1Tdze"};